import {
  LivretEleveCompetence,
  LivretEleveDomaine,
  LivretEleveMatiere,
} from '@teetsh/app/src/containers/Livrets/types/livret';

export function createCompetence(
  matiere: LivretEleveMatiere,
  competence: LivretEleveCompetence,
  domaine?: LivretEleveDomaine,
): LivretEleveMatiere {
  if (domaine) {
    const domaines = matiere.domaines.map(oldDomaine => {
      if (domaine && oldDomaine.id === domaine.id) {
        const matchingCompetenceByName = (oldDomaine?.competences || []).find(
          c => c.name === competence.name,
        );
        if (matchingCompetenceByName) {
          return oldDomaine;
        }
        return {
          ...oldDomaine,
          competences: [...(oldDomaine?.competences || []), competence],
        };
      }
      return oldDomaine;
    });
    return {
      ...matiere,
      domaines,
    };
  }
  const matchingCompetenceByName = (matiere.competences || []).find(
    c => c.name === competence.name,
  );
  if (matchingCompetenceByName) {
    return matiere;
  }
  return {
    ...matiere,
    competences: [...(matiere?.competences || []), competence],
  };
}
